import React from "react";
import SkillCard from "./SkillCard";

const skills = {
  frontend: [
    { name: "JavaScript", icon: "javascript.png" },
    { name: "CSS", icon: "css.png" },
    { name: "HTML5", icon: "html.png" },
    { name: "Express", icon: "express.png" },
  ],
  databases: [
    { name: "MySQL", icon: "mysql.png" },
    { name: "MongoDB", icon: "mongodb.png" },
    { name: "CosmosDB", icon: "cosmosdb.png" },
  ],
  languages: [
    { name: "Java", icon: "java.png" },
    { name: "C++", icon: "cplusplus.png" },
    { name: "Swift", icon: "swift.png" },
    { name: "C#", icon: "csharp.png" },
  ],
  frameworks: [
    { name: "Specflow", icon: "specflow.png" },
    { name: "React", icon: "react.png" },
    { name: "UIKit", icon: "uikit.png" },
    { name: "SwiftUI", icon: "swiftui.png" },
  ],
  other: [
    { name: "IdentityServer", icon: "identityserver.png" },
    { name: "Docker", icon: "docker.png" },
    { name: "Git", icon: "git.png" },
    { name: "Kafka", icon: "kafka.png" },
  ],
};

const SkillsSection = () => {
  return (
    <div className="grid w-full grid-cols-1 justify-items-center gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <SkillCard title="Front End" skills={skills.frontend} />
      <SkillCard title="Databases" skills={skills.databases} />
      <SkillCard title="Languages" skills={skills.languages} />
      <SkillCard title="Frameworks" skills={skills.frameworks} />
      <SkillCard title="Other" skills={skills.other} />
    </div>
  );
};

export default SkillsSection;
